<!-- ========================================================================================
      Author: Alizadeh
========================================================================================== -->

<!-- <template src="./Bills.html">-->
<template>
  <div>
    <vs-collapse class="p-0 m-0 bg-white" type="margin">
      <vs-collapse-item
        icon-pack="feather"
        icon-arrow="icon-chevron-down"
        :open="true"
      >
        <div slot="header">
          <feather-icon
            icon="FilterIcon"
            svgClasses="text-primary"
          ></feather-icon
          >فیلترها
        </div>
        <form
          @keyup.enter="
            pageNo = 1;
            getData();
          "
        >
          <div class="vx-row mb-2">
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-3/12 flex-inline">
                  <span>از تاریخ:</span>
                </div>
                <div class="vx-col sm:w-9/12 flex-inline">
                  <date-picker
                    inputClass="py-1 px-5  w-full"
                    v-model="filters.dateFrom"
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-3/12 flex-inline">
                  <span>تا تاریخ:</span>
                </div>
                <div class="vx-col sm:w-9/12 flex-inline">
                  <date-picker
                    inputClass="py-1 px-5 w-full"
                    v-model="filters.dateTo"
                  ></date-picker>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-3/12 flex-inline">
                  <span>از مبلغ:</span>
                </div>
                <div class="vx-col sm:w-9/12 flex-inline">
                  <vs-input
                    inputmode="numeric"
                    v-model="filters.minAmount"
                    v-focus
                    class="w-full"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-3/12 flex-inline">
                  <span>تا مبلغ:</span>
                </div>
                <div class="vx-col sm:w-9/12 flex-inline">
                  <vs-input
                    inputmode="numeric"
                    v-model="filters.maxAmount"
                    class="w-full"
                  />
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-3/12 flex-inline">
                  <span>نوع پرداخت:</span>
                </div>
                <div class="vx-col sm:w-9/12 flex-inline">
                  <v-select
                    class="selectExample w-full"
                    v-model="filters.paymentType"
                    :options="paymentTypes"
                  ></v-select>
                </div>
              </div>
            </div>
            <slot></slot>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-3/12 flex-inline">
                  <span>وضعیت:</span>
                </div>
                <div class="vx-col sm:w-9/12 flex-inline">
                  <v-select
                    class="selectExample w-full"
                    v-model="filters.state"
                    :options="states"
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="vx-col md:w-5/12 ml-5">
              <div class="vx-row mb-2">
                <div class="vx-col sm:w-3/12 flex-inline">
                  <span>متن:</span>
                </div>
                <div class="vx-col sm:w-9/12 flex-inline">
                  <vs-input v-model="filters.filter" class="w-full" />
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col">
              <vs-button
                @click="clear"
                class="mx-3"
                color="primary"
                type="border"
                >پاک کردن</vs-button
              >
            </div>
            <div class="vx-col">
              <vs-button
                @click="
                  pageNo = 1;
                  getData();
                "
                class="mx-3"
                color="primary"
                type="filled"
                icon-pack="feather"
                icon="icon-search"
                >جستجو</vs-button
              >
            </div>
            <div class="vx-col">
              <export-excel
                :data="itemsExcel"
                :exportFields="json_fields"
                worksheet="transactions"
                name="transactions.xls"
                :before-generate="getDataExcel"
              >
                <vs-button
                  class="mx-0"
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-download"
                  >دانلود</vs-button
                >
              </export-excel>
            </div>
          </div>
        </form>
      </vs-collapse-item>
    </vs-collapse>

    <vx-card class="mb-2">
      <slot name="title" />
      <vs-table
        search
        id="tbl2"
        ref="tbl2"
        stripe
        :data="transactions2"
        class="table-dark-inverted responsable-table"
      >
        <template slot="header">
          <div class="vx-row mb-2 w-full">
            <div class="vx-col sm:w-9/12 flex-inline">
              <div class="vx-row mb-2">
                <div class="vx-col">
                  <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                      <div
                        class="
                          p-3
                          border border-solid
                          d-theme-border-grey-light
                          rounded-full
                          d-theme-dark-bg
                          cursor-pointer
                          flex
                          items-center
                          justify-between
                          font-medium
                        "
                      >
                        <span class="mr-2">
                          {{ (pageNo - 1) * pageSize + 1 }}
                          -
                          {{
                            pageNo * pageSize > totalCount
                              ? totalCount
                              : pageNo * pageSize
                          }}
                          از {{ totalCount }}
                        </span>
                        <feather-icon
                          icon="ChevronDownIcon"
                          svgClasses="h-4 w-4"
                        />
                      </div>
                      <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                      <vs-dropdown-menu>
                        <vs-dropdown-item @click="SetPageSize(5)">
                          <span>5</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(10)">
                          <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(20)">
                          <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(50)">
                          <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(100)">
                          <span>100</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="SetPageSize(150)">
                          <span>150</span>
                        </vs-dropdown-item>
                      </vs-dropdown-menu>
                    </vs-dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template slot="thead">
          <vs-th>نوع پرداخت</vs-th>
          <vs-th>پرداخت کننده</vs-th>
          <vs-th>دریافت کننده</vs-th>
          <vs-th>تاریخ پرداخت</vs-th>
          <!-- <vs-th>شماره پیگیری بانک</vs-th>
          <vs-th>شماره پیگیری 20پی</vs-th>-->
          <vs-th>مبلغ</vs-th>
          <vs-th v-if="$acl.check('isOperator')"></vs-th>
          <vs-th></vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="tr.transaction.id" v-for="(tr, indextr) in data">
            <vs-td class="hide-title one-line">
              {{pageSize * (pageNo - 1)+ indextr+1 }}
              <feather-icon
                v-if="PaymentType[tr.transaction.paymentType]"
                :title="PaymentType[tr.transaction.paymentType].title"
                :icon="PaymentType[tr.transaction.paymentType].icon"
                svgClasses="h-6 w-6"
              ></feather-icon>
              <span v-if="PaymentType[tr.transaction.paymentType]">{{
                PaymentType[tr.transaction.paymentType].title
              }}</span>
            </vs-td>
            <vs-td :class="{ 'e-col': tr.sourceUserId == uid }">
              <span
                :style="tr.sourceUserId == uid ? 'opacity:0.5;' : ''"
                :title="tr.sourceMobile"
                >{{
                  tr.sourceName +
                  (tr.sourceUserId == uid ? "" : "(" + tr.sourceMobile + ")")
                }}</span
              >
            </vs-td>
            <vs-td :class="{ 'e-col': tr.destinationUserId == uid }">
              <span
                :style="tr.destinationUserId == uid ? 'opacity:0.5;' : ''"
                >{{ tr.destinationName }}</span
              >
            </vs-td>
            <vs-td>
              <span
                class="one-line"
                :title="
                  $moment(tr.transaction.paymentDateTime).format(
                    'HH:mm:ss jYYYY/jMM/jDD'
                  )
                "
                >{{
                  !tr.transaction.paymentDateTime
                    ? "&nbsp;"
                    : $moment(tr.transaction.paymentDateTime).format(
                        "HH:mm jYY/jMM/jDD"
                      )
                }}</span
              >
            </vs-td>
            <!-- <vs-td>
          <span>{{tr.transaction.traceNumber}}</span>
        </vs-td>
        <vs-td>
          <span>{{tr.transaction.trackingNumber}}</span>
            </vs-td>-->
            <vs-td :class="'text-' + stateIcon(tr).color" class="one-line">
              <span class="float-right d-only">
                <span>{{ formatAmount(tr) }}</span>
                <feather-icon
                  strokeWidth="2"
                  :title="stateIcon(tr).title"
                  :icon="stateIcon(tr).icon"
                  :svgClasses="'h-6 w-6 text-' + stateIcon(tr).color"
                  style="top: 7px"
                ></feather-icon>
              </span>

              <span class="m-only">
                {{ formatAmount(tr) }}
                <vs-button
                  :color="stateIcon(tr).color"
                  type="line"
                  icon-pack="feather"
                  :title="stateIcon(tr).title"
                  :icon="$helper.toKababCaseFeatherIcon(stateIcon(tr).icon)"
                  class="p-0 pb-1 pl-2 float-right"
                  @click="showDetails(tr.transaction.id)"
                >
                  جزئیات
                </vs-button>
                <vs-button
                  v-if="$acl.check('isOperator')"
                  :color="stateIcon(tr).color"
                  type="line"
                  class="p-0 pb-1 pr-1 float-right"
                  @click="showTransaction(tr.transactionId)"
                >
                  استعلام
                </vs-button>
              </span>
            </vs-td>
            <vs-td class="d-only" v-if="$acl.check('isOperator')">
              <a @click="inquiry(tr.transaction.id, tr.transaction.state)"
                >استعلام</a
              >
            </vs-td>
            <vs-td class="d-only">
              <a @click="showDetails(tr.transaction.id)">جزئیات</a>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <paginate
        v-model="pageNo"
        :page-count="pagesCount"
        :click-handler="()=>{getData()}"
      />
      <transaction-details ref="TransactionDetails1"></transaction-details>
      <transaction-inquiry ref="TransactionInquiry1" />
    </vx-card>
  </div>
</template>
<style  lang="scss">
.amount-nav {
  text-align: right;
  div {
    display: block;
    position: relative;
    span {
      top: 0px !important;
      position: absolute !important;
      left: 0;
      &:first-child {
        top: -2px !important;
      }
    }
    & + span {
      margin-left: 7px;
    }
  }
}
</style>
<script>
import vSelect from "vue-select";
import { PaymentType, PaymentGateway, TransactionState } from "@/enums.js";
import trans from "../../../http/requests/transactions.js";
import TransactionDetails from "../transaction/TransactionDetails.vue";
import TransactionInquiry from "../transaction/TransactionInquiry.vue";
export default {
  name: "transactions",
  props: {
    onlySource: {},
    isCurrentUser: { default: false, type: Boolean },
  },
  components: {
    "v-select": vSelect,
    TransactionDetails,
    TransactionInquiry,
  },
  data() {
    return {
      itemsExcel: [],
      transactions2: [],
      PaymentGateway,
      TransactionState,
      PaymentType,
      totalCount: 1,
      pageSize: 10,
      pagesCount: 1,
      pageNo: 1,
      fetchingTikes: 0,
      json_fields: {
        "نوع پرداخت": {
          field: "transaction.paymentType",
          callback: (value) => {
            return PaymentType[value].title;
          },
        },
        "شماره همراه پرداخت کننده": "sourceMobile",
        "نام پرداخت کننده": "sourceName",
        "دریافت کننده": "destinationName",
        تاریخ: {
          field: "transaction.paymentDateTime",
          callback: (value) => {
            return value
              ? this.$moment(value).format("jYYYY/jMM/jDD")
              : "&nbsp;";
          },
        },
        ساعت: {
          field: "transaction.paymentDateTime",
          callback: (value) => {
            return value ? this.$moment(value).format("HH:mm:ss") : "&nbsp;";
          },
        },
        مبلغ: {
          field: "transaction.amount1",
          callback: (value) => {
            return value;
          },
        },
        'وضعیت پرداخت': {
          field: "transaction.state",
          callback: (value) => {
            return TransactionState[value].title;
          },
        },
      },
      filters: {
        paymentType: "",
        maxAmount: "",
        minAmount: "",
        dateTo: "",
        dateFrom: "",
        filter: "",
        state: null,
      },
    };
  },
  computed: {
    paymentTypes: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.PaymentType)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    },
    states: function () {
      let ms = [];
      for (let [key, value] of Object.entries(this.TransactionState)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    },
    uid() {
      try {
        return this.$store.state.AppActiveUser.uid;
      } catch (e) {
        return "";
      }
    },
    title() {
      return this.$route.query.settlementDate
        ? `تراکنشهای تسویه‌حساب (${this.$moment(
            this.$route.query.settlementDate
          ).format("HH:mm:ss - jYYYY/jMM/jDD")})`
        : this.$route.query.shopName
        ? `تراکنشهای پذیرنده "${this.$route.query.shopName}"`
        : this.$route.query.username
        ? `تراکنشهای "${this.$route.query.username}"`
        : "";
    },
  },
  methods: {
    async getDataExcel() {
      await this.getData(true);
    },
    initFilters() {
      if (Object.keys(this.$route.query).length != 0) {
        this.$emit("initFilters");
        this.pageSize = this.$route.query.ps || this.pageSize;
        this.pageNo = parseInt(this.$route.query.pno) || this.pageNo;
        this.filters.minAmount = this.$route.query.na || this.filters.minAmount;
        this.filters.maxAmount = this.$route.query.xa || this.filters.maxAmount;
        this.filters.dateFrom = this.$route.query.df || this.filters.dateFrom;
        this.filters.dateTo = this.$route.query.dt || this.filters.dateTo;
        this.filters.filter = this.$route.query.f || this.filters.filter;
        this.filters.state = this.$route.query.s
          ? this.states.find((x) => x.value == this.$route.query.s)
          : this.filters.state;
        this.filters.paymentType = this.$route.query.pt
          ? this.paymentTypes.find((x) => x.value == this.$route.query.pt)
          : this.filters.paymentType;
      }
    },
    async getData(download = false) {
      const query = {
        ps: this.pageSize,
        pno: this.pageNo,
      };
      //if (this.$route.query.sett) query.sett = this.$route.query.sett;
      // if (this.sourceUserId) query.sid = this.sourceUserId;
      // if (this.DestinationUserId) query.did = this.DestinationUserId;
      // if (this.username) query.un = this.username;
      if (this.filters.maxAmount) query.xa = this.filters.maxAmount;
      if (this.filters.minAmount) query.na = this.filters.minAmount;
      if (this.filters.filter) query.f = this.filters.filter;
      if (this.filters.state) query.s = this.filters.state.value;
      if (this.filters.paymentType) query.pt = this.filters.paymentType.value;

      let loading = this.$vs.loading();
      let payload = {
        params: {
          //SettlementId: this.$route.query.sett,
          // SourceUserId: this.sourceUserId,
          // DestinationUserId: this.DestinationUserId,
          Filter: this.filters.filter,
          MaxAmount: this.filters.maxAmount,
          MinAmount: this.filters.minAmount,
          State: this.filters.state == null ? null : this.filters.state.value,
          PaymentType:
            this.filters.paymentType == null
              ? null
              : this.filters.paymentType.value,
          Sorting: "transaction.paymentDateTime DESC",
          MaxResultCount: download ? 2000 : this.pageSize,
          SkipCount: download ? 0 : this.pageSize * (this.pageNo - 1),
          FetchingTikes: this.fetchingTikes,
        },
      };

      if (this.onlySource) {
        payload.params.OnlySource = this.onlySource;
      }
      if (this.filters.dateFrom != "") {
        payload.params.PaymentDateTimeFrom = this.$moment(
          this.filters.dateFrom,
          "jYYYY/jMM/jDD"
        ).format();
        query.df = this.filters.dateFrom;
      }
      if (this.filters.dateTo != "") {
        payload.params.PaymentDateTimeTo = this.$moment(
          this.filters.dateTo,
          "jYYYY/jMM/jDD"
        ).format("YYYY-MM-DDT23:59:59.9999999Z");
        query.dt = this.filters.dateTo;
      }
      this.$emit("getData", { payload: payload, query: query });
      this.$router.replace({
        query: query,
      });

      const request = this.isCurrentUser
        ? trans.getUserTransactions(payload)
        : trans.getTransactions(payload);
      await request
        .then((response) => {
          if (download) {
            this.itemsExcel = response.data.result.data.items;
            this.itemsExcel.forEach((x) => {
              x.transaction.amount1 =
                x.transaction.amount - x.transaction.commissionFromConsumer;
            });
            if (response.data.result.data.totalCount > 2000)
              this.$vs.notify({
                time: 5000,
                color: "danger",
                title: "خطا!",
                text: `خروجی درخواست شما شامل ${response.data.result.data.totalCount} رکورد است.
                      <br/>
              خروجی اکسل تنها شامل 2000 رکورد ابتدایی می‌باشد.`,
              });
          } else {
            this.transactions2 = response.data.result.data.items;
            this.totalCount = response.data.result.data.totalCount;
            this.pagesCount = Math.ceil(this.totalCount / this.pageSize);
          }
          this.$vs.loading.close();
        }) //end success
        .catch((error) => {
          console.log(error);
          this.$vs.loading.close();
        }); //end http

      // this.$http
      //   .get("api/services/app/Transactions/GetAll", payload)
      //   .then(response => {
      //     this.transactions2 = response.data.result.data.items;
      //   }) //end success
      //   .catch(error => {
      //     console.log(error);
      //   }); //end http
    },
    clear() {
      this.filters.filter = "";
      this.filters.dateFrom = "";
      this.filters.dateTo = "";
      this.filters.minAmount = "";
      this.filters.maxAmount = "";
      this.filters.paymentType = "";
      this.filters.state = this.isCurrentUser
        ? this.states.find((x) => x.value == 1)
        : null;
    },
    SetPageSize(val) {
      this.pageSize = val;
      this.pageNo = 1;
      this.getData();
    },
    inquiry(id, state) {
      this.$refs.TransactionInquiry1.inquiry(id, state);
    },
    showDetails(id) {
      this.$refs.TransactionDetails1.show(id);
    },
    selected(tr) {},
    formatAmount(tr) {
      let s =
        tr.destinationUserId == this.uid && tr.sourceUserId == this.uid
          ? "±"
          : "";
      s += parseInt(
        tr.transaction.amount - tr.transaction.commissionFromConsumer
      ).toLocaleString();
      s +=
        tr.destinationUserId == this.uid
          ? tr.sourceUserId == this.uid
            ? ""
            : "+"
          : tr.sourceUserId == this.uid
          ? "-"
          : "";
      return s;
    },
    stateIcon(tr) {
      let icon = "";
      let title = "";
      let color = "";
      if (tr.transaction.state == 1) {
        if (tr.destinationUserId == this.uid) {
          icon = "ArrowUpIcon";
          title = "موفق";
          color = "success";
        } else if (tr.sourceUserId == this.uid) {
          icon = "ArrowDownIcon";
          title = "CheckCircleIcon";
          color = "danger";
        } else {
          icon = "CheckCircleIcon";
          title = "موفق";
          color = "success";
        }
      } else {
        icon = TransactionState[tr.transaction.state].icon;
        title = TransactionState[tr.transaction.state].title;
        color = TransactionState[tr.transaction.state].color;
      }
      return { icon, title, color };
    },
  },
  mounted() {
    this.filters.state = this.isCurrentUser
      ? this.states.find((x) => x.value == 1)
      : null;
    if (Object.keys(this.$route.query).length) {
      this.initFilters();
      this.getData();
    }
  },
};
</script>
